var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"minimal-header"}},[_c('div',{staticClass:"container no-padding"},[_c('div',{staticClass:"minimal-header"},[_c('header-logo',{staticClass:"minimal-header__logo"}),_vm._v(" "),(!_vm.isErrorPageView)?_c('account-button'):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }